import React from 'react';
import PropTypes from 'prop-types';

import FormError from "src/core/gd-form/common/form-error/form-error";
import FormRow from "src/core/gd-form/form/form-ui5/form-row";
import FormSelect from "core/gd-form/form-element/select-new/select-new";

export default function CustomFieldMaxSize(props) {

    const sizeOptions = [
        {label:'2 Lines', value: 2},
        {label:'3 Lines', value: 3},
        {label:'4 Lines', value: 4},
        {label:'5 Lines', value: 5},
        {label:'6 Lines', value: 6},
        {label:'8 Lines', value: 8},
        {label:'10 Lines', value: 10},
        {label:'12 Lines', value: 12},
    ];

    return (
        <FormRow label="Max Size">
            <FormSelect form={props.form}
                        name="size"
                        options={sizeOptions}
                        placeholder="Size" />
            <FormError form={props.form} name="size" />
        </FormRow>
    );
}

CustomFieldMaxSize.propTypes = {
    form: PropTypes.object
}